export { default as BgzfFilehandle } from './bgzFilehandle.ts'
export { unzip, unzipChunkSlice } from './unzip.ts'
